<template>
    <!-- progress bar start from here -->

    <div class="container mt-10">
        <ol class="steps">
            
          <!-- <li class="step " :class="[(1==step)? 'is-active' :(step>1)? 'is-complete' :'']" data-step="1">Organisation</li> -->
          <li class="step" :class="[(1==step)? 'is-active' :(step>1)? 'is-complete' :'']" data-step="1">Host</li>
          <li class="step" :class="[(2==step)? 'is-active' :(step>2)? 'is-complete':'']" data-step="2">Deploy</li>

          <!-- <li class="step" :class="[(3==step)? 'is-active' :(step>3)? 'is-complete':'']" data-step="3">Billing Info</li>
          <li class="step" :class="[(4==step)? 'is-active' :(step>4)? 'is-complete':'']" data-step="4">Place Order</li>
          <li class="step" :class="[(5==step)? 'is-active' :(step>5)?  'is-complete':'']" data-step="5">Checkout</li>
          <li class="step" :class="[(6==step)? 'is-active' :(step>6)?  'is-complete':'']" data-step="6">Deploy</li>
        -->
        </ol>
      </div>
      <!-- progress end  -->
</template>

<script>
export default {
   props: {
    step: String,
    step_1: "",
    step_2: "",
    step_3: "",
    step_4: "",
    step_5: "",
    step_6: "",
   }
}
</script>

<style>
/* progress css start here  */
.steps {
  list-style: none;
  margin: 0;
  padding: 0;
  display: table;
  table-layout: fixed;
  width: 100%;
  color: #929292;
  margin-top: 10px;
  height: 1rem;
}
.steps > .step {
  position: relative;
  display: table-cell;
  text-align: center;
  font-size: 0.875rem;
  color: #6d6875;
}
.steps > .step:before {
  content: attr(data-step);
  display: block;
  margin: 0 auto;
  background: #ffffff;
  border: 2px solid #e6e6e6;
  color: #e6e6e6;
  width: 2rem;
  height: 2rem;
  text-align: center;
  margin-bottom: -4.2rem;
  line-height: 1.9rem;
  border-radius: 100%;
  position: relative;
  z-index: 1;
  font-weight: 700;
  font-size: 1rem;
}
.steps > .step:after {
  content: "";
  position: absolute;
  display: block;
  background: #e6e6e6;
  width: 100%;
  height: 0.125rem;
  top: 1rem;
  left: 50%;
}
.steps > .step:last-child:after {
  display: none;
}
.steps > .step.is-complete {
  color: #6d6875;
}
.steps > .step.is-complete:before {
  content: "✓";
  color: #fff;
  background: #10b981;
  border: 2px solid #10b981;
}
.steps > .step.is-complete:after {
  background: #10b981;
}
.steps > .step.is-active {
  font-size: 1.25rem;
  margin-top: 10px;
}
.steps > .step.is-active:before {
  color: #fff;
  border: 2px solid #10b981;
  background: #10b981;
  margin-bottom: -4.9rem;
}

/**
* Some Generic Styling
 */
*,
*:after,
*:before {
  box-sizing: border-box;
}

h1 {
  margin-bottom: 1.5em;
}

.steps {
  margin-bottom: 1em;
}
/* progress end here */
</style>